import { render, staticRenderFns } from "./TicketsOptionInfo.vue?vue&type=template&id=56f6059f&scoped=true"
import script from "./TicketsOptionInfo.vue?vue&type=script&lang=js"
export * from "./TicketsOptionInfo.vue?vue&type=script&lang=js"
import style0 from "./TicketsOptionInfo.vue?vue&type=style&index=0&id=56f6059f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f6059f",
  null
  
)

export default component.exports